// Returns fn(pkg) -> included items minus the ones shared by most packages (>=40%).
export const distinctiveItems = (list) => {
  const counts = {};
  list.forEach((p) => new Set(p.included_items || []).forEach((it) => { counts[it] = (counts[it] || 0) + 1; }));
  const limit = Math.max(3, Math.ceil(list.length * 0.4));
  const common = new Set(Object.keys(counts).filter((k) => counts[k] >= limit));
  return (p) => {
    const items = p.included_items || [];
    const unique = items.filter((it) => !common.has(it));
    return unique.length ? unique : items;
  };
};
